import React from "react";
import HeroSection from "./components/Hero/HeroSection";
import HeroFooter from "./components/HeroFooter/HeroFooter";
import LifeAt from "./components/LifeAt/LifeAt";
import ObjectiveSection from "./components/Objective/ObjectiveSection";
import OurMission from "./components/OurMission/OurMission";
import OurTeam from "./components/OurTeam/OurTeam";
import Parallax1 from "./components/Parallax1/Parallax1";
import Parallax2 from "./components/Parallax2/Parallax2";
import Parallax3 from "./components/Parallax3/Parallax3";
const Home = () => {
  return (
    <div>
      <HeroSection />
      <HeroFooter />
      <ObjectiveSection />
      <Parallax1 />
      <OurMission />
      <Parallax2 />
      <OurTeam />
      <Parallax3 />
      <LifeAt />
    </div>
  );
};

export default Home;
